// extracted by mini-css-extract-plugin
export var chevron = "_g3-2";
export var dropdownItems = "_g3-0";
export var item = "_g3-1";